/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FeeModel } from './feeModel';
import { WorkflowStepModel } from './workflowStepModel';


/**
 * Encapsulates all information related to the workflow for a function
 */
export class WorkflowModel { 
    /**
     * Unique identifier for the Workflow
     */
    WorkflowID?: number;
    /**
     * Used for display purposes in the UI for the Workflow
     */
    WorkflowDisplayName?: string;
    /**
     * Represents the position in the Step array of the current step in the workflow
     */
    CurrentStepIndex?: number;
    /**
     * List of steps in the workflow
     */
    Steps?: Array<WorkflowStepModel>;
    /**
     * List of fees in the workflow to be used in the Pay step
     */
    Fees?: Array<FeeModel>;
}



// WEBPACK FOOTER //
// ./src/app/model/workflowModel.ts